'use strict';
/**
 *  createBy Qian.qianchen
 *  time:2019-01-21
 * Description Module  关键词
 */
angular.module('keyWordsModule', []).directive('keyWords', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
    // Runs during compile
    return {
        restrict: 'E',
        replace: false,
        templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/directive/keyWords/keyWords_tpl.html",
        scope: {
            wordsArr: "=",
            // keywordFlag: "="
        },
        link: function(scope, iElement, iAttrs) {
            initStatus();
            scope.$watch('wordsArr', function(newVal, oldVal) {
                initData();
            });

            function initStatus() {
                scope.status = {
                    inputShow: false
                };
                scope.data = {
                    keywords: []
                }
            }

            function initData() {
                scope.data.keywords = scope.wordsArr.map(function(currVal) {
                    return { value: currVal, isEdit: false };
                });
            }
            /**
             * [addKeyWords description] 添加关键词
             */
            scope.addKeyWords = function() {
                if ($('.keyWords_item').hasClass('add_error')) {
                    return;
                }
                if (scope.data.keywords.length > 0 && scope.data.keywords[0].isEdit && scope.data.keywords[0].value == '') {
                    var keywordsItems = $(iElement).find('.keyWords_item');
                    $(keywordsItems).eq(0).children('.keyWords_input').focus();
                    $(keywordsItems).eq(0).removeClass('add_error').addClass('add_error');
                } else {
                    scope.data.keywords.map(function(currItem) {
                        currItem.isEdit = false;
                    });
                    scope.data.keywords.unshift({ value: '', isEdit: true });
                    $timeout(function() {
                        var keywordsItems = $(iElement).find('.keyWords_item');
                        $(keywordsItems).eq(0).children('.keyWords_input').focus();
                    }, 100);
                }
            }
            /**
             * [deleteKeyWords description] 关键词删除
             * @param  {[type]} item [description]关键词对象
             * @return {[type]}      [description]
             */
            scope.deleteKeyWords = function(item) {
                scope.data.keywords.splice(scope.data.keywords.indexOf(item), 1);
                if (scope.wordsArr.indexOf(item.value) > -1) {
                    scope.wordsArr.splice(scope.wordsArr.indexOf(item.value), 1);
                }
                // console.log(scope.wordsArr);
                // if (item.value == "") {
                //     scope.keywordFlag = true;
                // }
            }
            /**
             * [editKeywords description] 编辑关键词
             * @param  {[type]} item [description] 关键词对象
             * @return {[type]}      [description]
             */
            scope.editKeywords = function(item) {
                item.isEdit = true;

            }
            /**
             * [editingKeywords description] 输入框回车保存关键词
             * @param  {[type]} item [description] 关键词对象
             * @param  {[type]} ev   [description] event
             * @return {[type]}      [description]
             */
            scope.editingKeywords = function(item, ev) {
                var keywordsItems = $(iElement).find('.keyWords_item');
                if (angular.isDefined(ev)) {
                    var keycode = window.event ? ev.keyCode : ev.which;
                    if (keycode == 13) {
                        $(keywordsItems).removeClass('add_error');
                        if (item.value == '') {
                            $(keywordsItems).eq(scope.data.keywords.indexOf(item)).removeClass('add_error').addClass('add_error');
                            return;
                        }
                        if (item.value.length > 10) {
                            item.value = item.value.substr(0, 10);
                        }
                        item.isEdit = false;
                        scope.wordsArr = scope.data.keywords.map(function(item) {
                            return item.value;
                        });
                    }
                } else {
                    if (item.value == '') {
                        scope.data.keywords.splice(scope.data.keywords.indexOf(item), 1);
                        return;
                    } else if (item.value.length > 10) {
                        item.value = item.value.substr(0, 10);
                        item.isEdit = false;
                        scope.wordsArr = scope.data.keywords.map(function(item) {
                            return item.value;
                        });
                    } else {
                        item.isEdit = false;
                        scope.wordsArr = scope.data.keywords.map(function(item) {
                            return item.value;
                        });
                    }

                }

            }
        }
    }
}]);